import { create } from "zustand";
import { combine } from "zustand/middleware";

/** What the API sends from GET /maintenance and in its 503 body. */
export interface MaintenanceStatus {
  active: boolean;
  message: string | null;
  startsAt: string | null;
  until: string | null;
}

export const MAINTENANCE_BYPASS_KEY = "maintenanceBypass";

/**
 * Token the team sets by hand (localStorage) to test the app while
 * maintenance is on. Sent as X-Maintenance-Bypass on every API request.
 */
export const getMaintenanceBypass = (): string | null => {
  try {
    return localStorage.getItem(MAINTENANCE_BYPASS_KEY) || null;
  } catch {
    return null;
  }
};

/** Spread into the headers of API requests made outside axios (Supertokens). */
export const maintenanceBypassHeaders = (): Record<string, string> => {
  const bypass = getMaintenanceBypass();

  return bypass ? { "X-Maintenance-Bypass": bypass } : {};
};

export const isMaintenanceResponse = (
  status: number | undefined,
  data: unknown
): data is MaintenanceStatus & { code: "MAINTENANCE" } =>
  status === 503 &&
  typeof data === "object" &&
  data !== null &&
  (data as { code?: unknown }).code === "MAINTENANCE";

export const useMaintenanceStore = create(
  combine({ status: null as MaintenanceStatus | null }, (set) => ({
    setStatus: (status: MaintenanceStatus | null) => set({ status }),
  }))
);
